import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import Search from '../Common/Search/Search';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

class Staff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchData:null
            ,openModal:false
            ,order:'asc'
            ,orderBy:'StaffId'
            ,page:0
            ,rowsPerPage:10
            ,tableLoading:false
        };
    }
    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getstaff")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (staffId) => {
        if(window.confirm("Tem a certeza que quer apagar este funcionário?")){
            this.setState({tableLoading:true});
            fetch(API + 'deletestaff&staffid=' + staffId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["staffId_" + staffId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchstaff&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData } = this.props;
        const staff = this.state.fetchData!=null ? this.state.fetchData.data : []
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'StaffId', active: true, numeric: false, className: 'smallerHeader', label: 'Id Int' },
                  { id: 'FirstName', numeric: false, label: 'Nome' },
                  { id: 'Gender', numeric: false, className: 'smallerHeader', label: 'Sexo' },
                  { id: 'JobShortnames', numeric: false, label: 'Funções' },
                  { id: 'CellPhone', numeric: false, label: 'Telemóvel' },
                  { id: 'Email', numeric: false, label: 'Email' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="staffPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-user-md"></i> Funcionários <span className="arrayCount">({staff.length})</span>
                            { (isAdmin || loginData.profile.Staff.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Funcionário"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Staff/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                            </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={staff.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(staff, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(staff =>
                            <TableRow key={staff.Id} className="tableRow" ref={"staffId_" + staff.Id}>
                                <TableCell data-title="Id Int" className="tableCell">{staff.StaffId}</TableCell >
                                <TableCell data-title="Nome" className="tableCell">{staff.FirstName} {staff.LastName}</TableCell >
                                <TableCell data-title="Sexo" className="tableCell smallerCell">{staff.Gender}</TableCell >
                                <TableCell data-title="Funções" className="tableCell">{staff.JobShortnames}</TableCell >
                                <TableCell data-title="Telemóvel" className="tableCell">{staff.CellPhone}</TableCell >
                                <TableCell data-title="Email" className="tableCell">{staff.Email}</TableCell >
                                <TableCell data-title="Ativo" className="tableCell smallerCell">{booleanConvert(staff.IsActive)}</TableCell >
                                <TableCell data-title="Ações" className="tableCell actions actionsBig" data-row-id={staff.Id}>
                                    {(isAdmin || (loginData.profile.Staff && loginData.profile.Schedules)) &&
                                        <Tooltip
                                            title={"Ver horário do Funcionário"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Staff/Schedules/"+staff.Id}><i className="fa fa-clock"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Staff.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Funcionário"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Staff/"+staff.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {loginData.profile.Staff && loginData.profile.Staff.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Funcionário"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Staff/"+staff.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Staff.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Funcionário"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(staff.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={staff.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Staff;
